const id_return_customer_type = {
    "": "tipe retur pelanggan",
    add: "tambah tipe retur pelanggan",
    edit: "ubah tipe retur pelanggan",

    label: {
        name: 'nama tipe',
        commission: "potongan komisi ( % )",
    },
    error: {
        name: "Nama tipe tidak boleh kosong.",
        create: "Gagal membuat tipe retur pelanggan.",
        delete: "Gagal menghapus tipe retur pelanggan.",
        edit: "Gagal mengubah tipe retur pelanggan.",
    },
    success: {
        create: "Berhasil membuat tipe retur pelanggan.",
        delete: "Berhasil menghapus tipe retur pelanggan.",
        edit: "Berhasil mengubah tipe retur pelanggan.",
    },
}

export default id_return_customer_type;